export const EmojiCdnProvider = {
  JSDELIVR_APPLE: 'jsdelivr-apple',
  JSDELIVR_GOOGLE: 'jsdelivr-google',
  TWEMOJI: 'twemoji',
  NATIVE: 'native'
} as const;

export type EmojiCdnProviderType =
  (typeof EmojiCdnProvider)[keyof typeof EmojiCdnProvider];

export const EMOJI_CDN_URLS: Record<EmojiCdnProviderType, string | null> = {
  [EmojiCdnProvider.JSDELIVR_APPLE]:
    'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64',
  [EmojiCdnProvider.JSDELIVR_GOOGLE]:
    'https://cdn.jsdelivr.net/npm/emoji-datasource-google@16.0.0/img/google/64',
  [EmojiCdnProvider.TWEMOJI]:
    'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72',
  [EmojiCdnProvider.NATIVE]: null
};

export const EMOJI_CDN_PROVIDER: EmojiCdnProviderType =
  EmojiCdnProvider.JSDELIVR_APPLE;

export const EMOJI_IMG_SIZE = 64;

/** Таймаут ожидания загрузки CDN-изображений при открытии пикера (мс) */
export const EMOJI_PRELOAD_TIMEOUT_MS = 5000;

/** Размер пачки при batch-загрузке (4 строки сетки по 8 колонок) */
export const EMOJI_PRELOAD_BATCH_SIZE = 32;

export const EMOJI_LIST: string[] = [
  // Smileys: happy / positive
  '😀',
  '😁',
  '😂',
  '🤣',
  '😃',
  '😄',
  '😅',
  '😆',
  '😇',
  '🙂',
  '🙃',
  '😉',
  '😊',

  // Smileys: love / affection
  '😍',
  '🥰',
  '😘',
  '😗',
  '😙',
  '😚',
  '🥲',
  '🤩',
  '😋',
  '😛',
  '😜',
  '🤪',
  '😝',

  // Smileys: neutral / thinking
  '🤑',
  '🤗',
  '🤭',
  '🤫',
  '🤔',
  '🤐',
  '🤨',
  '😐',
  '😑',
  '😶',
  '😏',
  '😒',
  '🙄',

  // Smileys: sick / tired / sleepy
  '😬',
  '🤥',
  '😌',
  '😔',
  '😪',
  '🤤',
  '😴',
  '😷',
  '🤒',
  '🤕',
  '🤢',
  '🤮',
  '🤧',

  // Smileys: extreme states
  '🥵',
  '🥶',
  '🥴',
  '😵',
  '🤯',
  '🤠',
  '🥸',
  '😎',
  '🤓',
  '🧐',
  '😕',
  '😟',
  '🙁',

  // Smileys: sad / scared
  '☹️',
  '😮',
  '😯',
  '😲',
  '😳',
  '🥺',
  '😦',
  '😧',
  '😨',
  '😰',
  '😥',
  '😢',
  '😭',

  // Smileys: angry / distressed
  '😱',
  '😖',
  '😣',
  '😞',
  '😓',
  '😩',
  '😫',
  '🥱',
  '😤',
  '😡',
  '😠',
  '🤬',
  '😈',

  // Fantasy / special characters
  '👿',
  '💀',
  '☠️',
  '💩',
  '🤡',
  '👹',
  '👺',
  '👻',
  '👽',
  '👾',
  '🤖',

  // Cat faces
  '😺',
  '😸',
  '😹',
  '😻',
  '😼',
  '😽',
  '🙀',
  '😿',
  '😾',

  // Hand gestures: open / spread
  '👋',
  '🤚',
  '🖐️',
  '✋',
  '🖖',

  // Hand gestures: shaped
  '👌',
  '🤌',
  '🤏',
  '✌️',
  '🤞',
  '🤟',
  '🤘',
  '🤙',

  // Hand gestures: pointing / directional
  '👈',
  '👉',
  '👆',
  '🖕',
  '👇',
  '☝️',

  // Hand gestures: fist / power / approval
  '✊',
  '👊',
  '🤛',
  '🤜',
  '👍',
  '👎',

  // Hand gestures: social / expressive
  '👏',
  '🙌',
  '👐',
  '🤲',
  '🤝',
  '🙏',
  '✍️',
  '💅',
  '🤳',
  '🫶',

  // Body: strength / limbs
  '💪',
  '🦾',
  '🦵',
  '🦿',
  '🦶',

  // Body: sensory
  '👂',
  '🦻',
  '👃',

  // Body: organs
  '🫀',
  '🫁',
  '🧠',

  // Body: face / external
  '🦷',
  '🦴',
  '👁️',
  '👀',
  '👅',
  '👄',
  '🫦',

  // Symbols / misc
  '💋',
  '🩸',
  '❤️',
  '🔥',
  '💯',
  '⭐',
  '✨',
  '🎉',
  '🎊'
];
